import type {NamedSetState} from 'app/gemStore/devtools';

import type {ModalComponentSlice, ModalComponentState} from './types';

const defaultState: ModalComponentState = {
    isOpen: false,
    url: '',
};

export const createModalComponentSlice = (set: NamedSetState<ModalComponentSlice>) => ({
    modalComponent: {...defaultState},
    openModal: ({url, modalType, callback, additionalAttributes, hash, formAppScriptPath, showCloseButton = true}: ModalComponentState) =>
        set(
            {
                modalComponent: {
                    url,
                    callback,
                    additionalAttributes,
                    hash,
                    modalType,
                    formAppScriptPath,
                    showCloseButton,
                    isOpen: true,
                },
            },
            false,
            'modal/openModal',
        ),
    closeModal: () => set({modalComponent: {...defaultState}}, false, 'modal/closeModal'),
});
